<div class="home" data-testid="epp-home-container">
  <div class="body">
    <div class="header mt-1 mb-3">
      <img src="/assets/images/epp/epp-logo.png" width="340px">
    </div>
    <div class="image-display">
      <img src="https://oes-hosted-images-public.s3.amazonaws.com/epp1.jpg" />
      <img src="https://oes-hosted-images-public.s3.amazonaws.com/epp2.jpg" />
      <img src="https://oes-hosted-images-public.s3.amazonaws.com/epp3.jpg" />
    </div>
    <div class="help-banner">
      <h4>{{ 'home.questions-1' | translate }}</h4>
      <p>{{ 'home.questions-2' | translate }}</p>
    </div>
  </div>
</div>


